import React from "react";
import { Link } from "react-scroll";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import logo from "../assets/splash logo.svg";
import { IoIosMenu } from "react-icons/io";

export const Hamburger = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div className="w-full">
      <div className="flex w-full flex-row h-17 justify-between" style={{
        position: 'fixed',
        top: 0,
        zIndex: 1000,
        backgroundColor: 'white',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
      }}>
        <div className="flex-grow">
          <Button
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <IoIosMenu className="text-lg w-11 h-21" style={{color: '#150958'}}/>
          </Button>
        </div>
        <Link 
          activeClass="active"
          to="home"
          spy={true}
          smooth={true}
          offset={-70}
          duration={500}
          className="flex-shrink-0 flex flex-row mr-4 justify-between items-center">
          <img
            src={logo}
            alt=""
            className="w-[16px] h-[16px]"
          />
          <h1 className="uppercase font-bold text-[12px]">
            swop
          </h1>
        </Link>
      </div>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={handleClose}>
          <Link
            activeClass="active"
            to="home"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            className="no-underline font-bold text-[14px]  text-indigo-950 ml-8 lg:ml-10 md:ml-3 sm:ml-3"
          >
            Home
          </Link>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Link
            activeClass="active"
            to="features"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            className="no-underline font-bold text-[14px]  text-indigo-950 ml-8 lg:ml-10 md:ml-3 sm:ml-3"
          >
            Features
          </Link>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Link
            activeClass="active"
            to="pricing"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            className="no-underline font-bold text-[14px]  text-indigo-950 ml-8 lg:ml-10 md:ml-3 sm:ml-3"
          >
            Pricing
          </Link>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Link
            activeClass="active"
            to="about"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            className="no-underline font-bold text-[14px]  text-indigo-950 ml-8 lg:ml-10 md:ml-3 sm:ml-3"
          >
            About
          </Link>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Link
            activeClass="active"
            to="faq"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            className="no-underline font-bold text-[14px]  text-indigo-950 ml-8 lg:ml-10 md:ml-3 sm:ml-3"
          >
            FAQs
          </Link>
        </MenuItem>
      </Menu>
    </div>
  );
};
